import BaseValidator from 'services/validations/base-validator';

class MaxLockedPlayersOnPositionValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {sportConfig} = this.dependencies;

        const positions = sportConfig.getConfigProp('positions', {});
        const positionsOrder = sportConfig.getConfigProp('positionsOrder', []);
        const lockedPlayerIds = this.getLockerPlayerIds();
        const lockedPlayerPositionNumbers = this.getLockedPlayerPositionNumbers(lockedPlayerIds);

        if (isEmpty(lockedPlayerPositionNumbers)) {
            return;
        }

        let maxLockedPlayers = 0;
        const positionNames: string[] = [];
        positionsOrder.map((position) => {
            // @ts-ignore
            const duplicates = arrayDuplicates(lockedPlayerPositionNumbers, position.allowedPositions);

            if (isEmpty(duplicates)) {
                return;
            }

            duplicates.map((positionNumber) => positionNames.push(positions[positionNumber].shortName));

            maxLockedPlayers++;
        });

        if (maxLockedPlayers < lockedPlayerIds.length) {
            // @ts-ignore
            this.addError(
                `The max number of players on ${arrayUnique(positionNames).join(', ')} positions you can lock in total is ${maxLockedPlayers}.`,
            );
        }
    }

    private getLockerPlayerIds(): number[] {
        // @ts-ignore
        const {playersLock, playersIndexedById} = this.dependencies;

        return playersLock.getMergedLockedPlayerIds().filter((playerId) => playerId in playersIndexedById);
    }

    private getLockedPlayerPositionNumbers(lockedPlayerIds): number[] {
        // @ts-ignore
        const {playersIndexedById} = this.dependencies;

        let lockedPlayerPositionNumbers: number[] = [];
        lockedPlayerIds.map((playerId) => {
            playersIndexedById[playerId]?.position.map((value) => lockedPlayerPositionNumbers.push(value));
        });

        return arrayUnique(lockedPlayerPositionNumbers);
    }
}

export {MaxLockedPlayersOnPositionValidator};
